import { SITE_CONFIG } from './site-config.actions';

const INIT_STATE = {};

export function SiteConfigReducer(state = INIT_STATE, { type, payload }) {
  switch (type) {
    case SITE_CONFIG.UPDATED:
      return { ...payload };
    default:
      return state;
  }
}
